import { render } from "./CategoryGrid.vue?vue&type=template&id=04584db4"
import script from "./CategoryGrid.vue?vue&type=script&lang=js"
export * from "./CategoryGrid.vue?vue&type=script&lang=js"

import "./CategoryGrid.vue?vue&type=style&index=0&id=04584db4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__